import { CommonModule } from '@angular/common';
import { NgModule, inject } from '@angular/core';
import { Route } from '@angular/router';
import { FullCalendarModule } from '@fullcalendar/angular';
import { AppTemplateModule } from '../app-template/app-template.module';
import { AppMenuItem } from '../app-template/models/app-menu-item.model';
import { AppTab } from '../app-template/models/app-tab.model';
import { MainAppService } from '../app-template/services/main-app.service';
import { DatabaseUser } from '../database/shared/database-user.entity';
import { EnaioDocumentsModule } from '../enaio-documents/enaio-documents.module';
import { EnaioWorkflowsRoutingModule } from '../enaio-workflows/enaio-workflows-routing.module';
import { PrimeModule } from '../prime/prime.module';
import { FeatureModule } from '../sm-base/models/feature.module';
import { FrontendFieldDefinition } from '../sm-base/models/frontend-field-definition.model';
import { FrontendFieldType } from '../sm-base/models/frontend-field-type.enum';
import { FrontendFormDefinition } from '../sm-base/models/frontend-form-definition.model';
import { RestEndpoint } from '../sm-base/models/rest-endpoint.model';
import { FeatureModuleService } from '../sm-base/services/feature-module.service';
import { SmBaseModule } from '../sm-base/sm-base.module';
import { Utils } from '../utils/shared/utils';
import { EnaioWorkItemComponent } from './components/enaio-work-item/enaio-work-item.component';
import { EnaioWorkflowsMainComponent } from './components/enaio-workflows-main/enaio-workflows-main.component';
import { PersonellFileComponent } from './components/personell-file/personell-file.component';
import { Config } from '../app-template/models/config.model';
import { EnaioWorkflowsConfig } from './enaio-workflows.config';

@NgModule({
    declarations: [
        EnaioWorkflowsMainComponent,
        EnaioWorkItemComponent,
        PersonellFileComponent
    ],
    imports: [
        AppTemplateModule,
        CommonModule,
        PrimeModule,
        SmBaseModule,
        EnaioDocumentsModule,
        EnaioWorkflowsRoutingModule,
        FullCalendarModule
    ]
})
export class EnaioWorkflowsModule implements FeatureModule {

    app = inject(MainAppService);
    featureModuleService = inject(FeatureModuleService);

    constructor() {
        this.featureModuleService.register(this);
    }

    registerSidebar(model: AppTab[]): void {
        model.push(new AppTab("workflows", "Workflows", "", 100, [
            Utils.fromPlain(AppMenuItem, { sort: 170, label: "Workflows", icon: "", routerLink: ["/enaio-workflows", "home"] })
        ]));

        EnaioDocumentsModule.mainBreadcrumb =  { label: "Personalakte", routerLink: ["/enaio-documents", "home"] };
    }

    async beforeAppStart(): Promise<void> {
        if (Config.get().getModuleConfig(EnaioWorkflowsConfig).fd) {
            if (!this.app.auth.isLoggedIn()) {
                return;
            }
            let user = this.app.auth.userDetails.getDatabaseUser();
            if (user == null) {
                //PRAGMATIC: Das bedeutet normalerweise, dass der Benutzer nicht mehr existiert oder ausgeschieden ist.
                this.app.auth.logout();
                return;
            }
            if (Utils.isNoe(user.getAttributeValue("EMailPortal"))) {
                let form = new FrontendFormDefinition([
                    new FrontendFieldDefinition("infoText", "Sie haben noch keine E-Mail Adresse festgelegt. An diese Adresse werden Benachrichtungen zu Ihren Anträgen verschickt.", FrontendFieldType.text, { hasControl: false }),
                    Utils.isNoe(user.getAttributeValue("EMail")) ? null : new FrontendFieldDefinition("def", "Formel D Adresse " +  user.getAttributeValue("EMail") + " verwenden", FrontendFieldType.buttonAsLink, { onClick: () => {
                        form.setValue("mail", user.getAttributeValue("EMail"));
                        form.setValue("mail2", user.getAttributeValue("EMail"));
                    }}),
                    new FrontendFieldDefinition("mail", "Mail-Adresse", FrontendFieldType.text, { mandatory: true, isEmailAddress: true }),
                    new FrontendFieldDefinition("mail2", "Mail-Adresse wiederholen", FrontendFieldType.text, { mandatory: true, isEmailAddress: true, validator: (field, item) => field.getValue() != item.getValue("mail") ? "Die Mail-Adressen müssen übereinstimmen" : null  })
                ]);
                let result = await this.app.messageDialog.formGetObject(form, "Ersteinrichtung", false);
                if (result != null) {
                    await RestEndpoint.main().post().body({ mail: result.mail }).run("api/wfl/tbr/setMail").getString();
                }
            }
        }
    }

    async updateSidebarVisibility(_: AppTab[]): Promise<void> {
    }

    getMainRoute(): Route {
        return this.featureModuleService.createModuleRoute("enaio-workflows", () => EnaioWorkflowsRoutingModule);
    }
}
